import { ModalHandler } from '@app-velocity/ui';

import { NewPluginVersionModalContent } from './components/NewPluginVersionModalContent';

export const NewPluginVersionModal = () => {
  return (
    <ModalHandler channel="system" id="new-plugin-version">
      <NewPluginVersionModalContent />
    </ModalHandler>
  );
};
